import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function setFavicon(iconPath) {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = iconPath.endsWith('.svg') ? 'image/svg+xml' : 'image/png';
  link.rel = 'icon';
  link.href = iconPath;
  document.getElementsByTagName('head')[0].appendChild(link);
}

// Swaps the favicon per-app; page `<title>` itself is owned by each page
// component (Home/AppDetailPage/LegalPage already set document.title).
function FaviconHandler() {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/onyxai')) {
      setFavicon('/images/onyxai_logo.png');
    } else if (path.startsWith('/lunicaai')) {
      setFavicon('/images/lunica_logo.png');
    } else if (path.startsWith('/aeropace') || path.startsWith('/app/cadet-pilot') || path.startsWith('/astryx')) {
      setFavicon('/images/aweropace.png');
    } else if (path.startsWith('/socialfridgemagnets') || path.startsWith('/app/social-fridge-magnets')) {
      setFavicon('/images/social-fridge-logo.png');
    } else {
      setFavicon('/images/onyxup_logo.svg');
    }
  }, [location.pathname]);

  return null;
}

export default FaviconHandler;
